/** Local AU mobile: 04XXXXXXXX */
export const AUSTRALIAN_MOBILE_LOCAL = /^04\d{8}$/;

/** E.164 AU mobile: +614XXXXXXXX */
export const AUSTRALIAN_MOBILE_E164 = /^\+614\d{8}$/;

/** Formats accepted by customer onboarding personal-details. */
export const AUSTRALIAN_MOBILE_COMPLETE = /^(04\d{8}|\+614\d{8})$/;

/** Canonical API storage format (no +): 614XXXXXXXX */
export const AUSTRALIAN_MOBILE_CANONICAL = /^614\d{8}$/;

export function isCompleteAustralianMobile(value: string): boolean {
  return AUSTRALIAN_MOBILE_COMPLETE.test(value);
}

/**
 * Progressive typing check for live form validation.
 * Allows incomplete prefixes (`0`, `04`, `+61`, `+614…`) but rejects spaces,
 * dashes, landlines, and bare `614…` / `412…` forms the API does not accept.
 */
export function isProgressiveAustralianMobile(value: string): boolean {
  if (!value) return true;
  if (/[\s-]/.test(value)) return false;

  if (value.startsWith('+')) {
    if (value === '+') return true;
    if (value === '+6') return true;
    if (value === '+61') return true;
    if (!/^\+614\d*$/.test(value)) return false;
    return value.length <= 12;
  }

  if (value === '0') return true;
  if (!/^04\d*$/.test(value)) return false;
  return value.length <= 10;
}

/**
 * Map API canonical / E.164 values to the local `04…` display used in forms.
 */
export function displayAustralianMobile(value?: string | null): string {
  if (!value) return '';
  if (AUSTRALIAN_MOBILE_CANONICAL.test(value)) return `04${value.slice(3)}`;
  if (AUSTRALIAN_MOBILE_E164.test(value)) return `04${value.slice(4)}`;
  return value;
}
